import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-home-why-stay-at',
  imports: [TranslatePipe],
  templateUrl: './home-why-stay-at.html',
  styleUrl: './home-why-stay-at.scss',
})
export class HomeWhyStayAt {}
